import Dropdown from 'react-bootstrap/Dropdown';
import {  useNavigate} from 'react-router-dom';

function BasicExample() {
    const navigate = useNavigate();

    const navigatePan = () => {
      
    
        navigate('/PanOCR');
      };

  return (

   

    <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
      <h1> Proceed with OCR</h1>
        OCR TYPES

        
      </Dropdown.Toggle>
    

      <Dropdown.Menu>
        <Dropdown.Item href="/PanOCR">
            <button onClick={navigatePan}>PAN OCR</button></Dropdown.Item>
        <Dropdown.Item href="#/action-2">Cheque</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Bank Statement</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Adhaar</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Passport</Dropdown.Item>

        <Dropdown.Item href="#/action-3">Driving license</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Voter ID</Dropdown.Item>
        <Dropdown.Item href="#/action-3">DP Statement</Dropdown.Item>



        
        
        
        
        

      </Dropdown.Menu>
    </Dropdown>
  );
}

export default BasicExample;